import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';

interface Props {
  icon: string;
  label: string;
  value?: string;
  to?: string;
  onClick?: () => void;
  trailing?: ReactNode;
  destructive?: boolean;
}

export function SettingsRow({ icon, label, value, to, onClick, trailing, destructive }: Props) {
  const navigate = useNavigate();
  const handle = () => {
    if (onClick) onClick();
    else if (to) navigate(to);
  };
  const style = destructive ? { color: 'var(--status-alert, #d33)' } : undefined;
  // Use div with role=button instead of <button> so nested interactive children
  // (e.g. Switch toggle) don't violate "<button> cannot contain a nested <button>"
  // hydration constraint.
  return (
    <div
      role="button"
      tabIndex={0}
      className="profile-row"
      onClick={handle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handle();
        }
      }}
      style={style}
    >
      <span className="material-symbols-outlined profile-row-icon" aria-hidden="true">
        {icon}
      </span>
      <span className="profile-row-label">{label}</span>
      {value ? <span className="profile-row-value">{value}</span> : null}
      {trailing}
      {!trailing && (to || (onClick && !destructive)) ? (
        <span className="material-symbols-outlined profile-row-icon" aria-hidden="true">
          chevron_right
        </span>
      ) : null}
    </div>
  );
}
